import React from 'react';
import { useTranslation } from 'react-i18next';
import Link from '~/common/components/Link';
import PromotionalBanner from './PromotionalBanner';

export const AXE_PRODUCT_VISION_WEBINAR_BANNER_EXPIRATION_DATE = new Date(
  '2026-06-25T15:30:00Z'
);
export const AXE_PRODUCT_VISION_WEBINAR_BANNER_REGISTRATION_URL =
  'https://accessibility.deque.com/mid-year-product-vision-webinar';

export const AxeProductVisionWebinarBanner = () => {
  const { t } = useTranslation();

  return (
    <PromotionalBanner
      expiresAt={AXE_PRODUCT_VISION_WEBINAR_BANNER_EXPIRATION_DATE}
      dismissed="permanently"
      storageKey="axe_product_vision_webinar_banner"
    >
      {t(
        `Upcoming: Mid-year product vision webinar. Learn what’s new and what’s coming next from Deque.`
      )}{' '}
      <Link url={AXE_PRODUCT_VISION_WEBINAR_BANNER_REGISTRATION_URL}>
        {t('Register Now.')}
      </Link>
    </PromotionalBanner>
  );
};
